import { ICreateApkState } from './createApkContext';
import {
	CreateApkActionTypes,
	TCreateApkAction,
} from 'modules/FirmwareAndApp/Apk/CreateApk/createApkState/createApkActions';

export const createApkReducer = (state: ICreateApkState, action: TCreateApkAction): ICreateApkState => {
	switch (action.type) {
		case CreateApkActionTypes.CHANGE_VERSION_NAME:
			return {
				...state,
				versionName: action.payload.versionName,
			};
		case CreateApkActionTypes.CHANGE_VERSION_CODE:
			return {
				...state,
				versionCode: action.payload.versionCode,
			};
		case CreateApkActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateApkActionTypes.CHANGE_APPLICATION_ID:
			return {
				...state,
				applicationId: action.payload.applicationId,
			};
		case CreateApkActionTypes.SET_PARAMETER_OF_APK_TYPE:
			return {
				...state,
				parameterOfApkType: action.payload.parameterOfApkType,
				IDSelectedApkType: null,
				isCutoverBeforeUpdate: false,
			};
		case CreateApkActionTypes.SET_ID_APK_TYPE:
			return {
				...state,
				IDSelectedApkType: action.payload.IDApkType,
				isCutoverBeforeUpdate: false,
			};
		case CreateApkActionTypes.TOGGLE_CUTOVER_BEFORE_UPDATE:
			return {
				...state,
				isCutoverBeforeUpdate: !state.isCutoverBeforeUpdate,
			};
		case CreateApkActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case CreateApkActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateApkActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateApkActionTypes.RESET_FIELDS:
			return {
				...state,
				versionName: '',
				versionCode: '',
				description: '',
				applicationId: '',
				parameterOfApkType: null,
				IDSelectedApkType: null,
				isCutoverBeforeUpdate: false,
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
